import { NavLink } from 'react-router-dom';
import { Button } from '../ui/button';
import { LogOut } from 'lucide-react';
import CurrencySelector from '../CurrencySelector';
import { SetPasswordDialog } from '../auth/SetPasswordDialog';

export const MobileMenu = ({ navItems, user, onClose, onLogout }) => (
  <div className="md:hidden fixed inset-0 z-40 bg-black/50" onClick={onClose}>
    <div
      className="absolute top-16 left-0 right-0 bg-white border-b border-[#D1D1CD] p-4"
      onClick={(e) => e.stopPropagation()}
    >
      <nav className="space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-colors ${
                isActive
                  ? 'bg-[#2E4632] text-white'
                  : 'text-[#5C5C5C] hover:bg-[#E8E8E3]'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-4 pt-4 border-t border-[#D1D1CD]">
        <label className="text-xs font-medium text-[#5C5C5C] uppercase tracking-wide mb-2 block">
          Currency
        </label>
        <CurrencySelector compact />
      </div>
      {user?.has_password === false && (
        <div className="mt-4">
          <SetPasswordDialog />
        </div>
      )}
      <Button
        onClick={onLogout}
        variant="outline"
        className="w-full h-10 mt-4 border-[#BC4749] text-[#BC4749]"
      >
        <LogOut className="w-4 h-4 mr-2" />
        Logout
      </Button>
    </div>
  </div>
);
